import React from 'react';
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const leadTimeText = (d) => `${d} ${d === 1 ? 'day' : 'days'}`;

const PriceMatrixHead = (props) => {
  const text = props.leadTimeText || leadTimeText
  return (
    <thead>
      <tr>
        <th className="qty">Qty</th>
        {props.leadTimes.map((qty) => <th key={qty}>{text(qty)}</th>)}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
};

const PriceMatrixBody = (props) => (
  <tbody>
    {props.quantities.map((qty, row) => (
      <PriceMatrixRow
        key={row}
        quantity={qty}
        row={row}
        {...props} />
    ))}
  </tbody>
);

// PriceMatrixBody.defaultProps = {
//   quantities: [],
// };

PriceMatrixBody.propTypes = {
  quantities: PropTypes.array.isRequired,
}

const PriceMatrixRow = (props) => {
  const MatrixCell = props.matrixCell ? props.matrixCell : PriceMatrixCell;
  return (
    <tr>
      <td className="qty">{props.quantity}</td>
      {props.leadTimes.map((leadTime, col) => (
        <MatrixCell
          key={col}
          leadTime={leadTime}
          col={col}
          {...props} />
      ))}
    </tr>
  );
};

// PriceMatrixRow.defaultProps = {
//   leadTimes: [],
// };

PriceMatrixRow.propTypes = {
  leadTimes: PropTypes.array.isRequired,
}

const PriceMatrix = (props) => {
  const lineItem = props.lineItem.toJS ? props.lineItem.toJS() : props.lineItem

  const leadTimes = lineItem.lead_times;
  const { quantities } = lineItem;
  const cssClass = classnames('table table-bordered table-price-matrix', {
    'table-striped': props.tableStripe,
    'table-sm': props.tableSm,
  })
  return (
    <div className="table-responsive">
      <table className={cssClass}>
        <PriceMatrixHead leadTimes={leadTimes} leadTimeText={props.leadTimeText} />
        <PriceMatrixBody
          quantities={quantities}
          leadTimes={leadTimes}
          {...props} />
      </table>
    </div>
  );
};

PriceMatrix.defaultProps = {
  tableStripe: true,
  tableSm: false,
  leadTimeText: null,
}

PriceMatrix.propTypes = {
  lineItem: PropTypes.object.isRequired,
  tableStripe: PropTypes.bool,
  tableSm: PropTypes.bool,
  leadTimeText: PropTypes.func,
  quoteStep: PropTypes.string.isRequired,
}

export default PriceMatrix;
